<template>
  <div class="content">
    <div class="md-layout">
      <md-card>
        <md-card-header :data-background-color="dataBackgroundColor">
          <h4 class="title">Registros Servicio De Atención en Tierra</h4>
          <p class="category">Buscar vuelo por número de constancia, fecha, regional y número de vuelo</p>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100 md-medium-size-40">
              <md-field>
                <label>Número de Vuelo</label>
                <md-input v-model="numeroVuelo" placeholder="Ingrese Número de Vuelo" />
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-medium-size-40">
              <md-field>
                <label>Número de Constancia</label>
                <md-input v-model="constancia" placeholder="Ingrese Número de Constancia" />
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-medium-size-30">
              <md-field>
                <label></label>
                <md-input type="date" v-model="fecha" />
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-medium-size-30">
              <md-field>
                <label></label>
                <select v-model="regional">
                  <option value="" disabled>Seleccione Regional</option>
                  <option v-for="reg in regionales" :key="reg.id" :value="reg.id">{{ reg.nombre }}</option>
                </select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100" style="display: flex; align-items: flex-end;">
              <md-button class="md-raised md-primary" @click="buscarVuelos">Buscar</md-button>
              <md-button class="md-raised" style="margin-left: 1em;" @click="limpiarBusqueda">Limpiar
                búsqueda</md-button>
            </div>
          </div>

          <div class="tabla-responsive">
            <md-table v-if="vuelos.length">
              <thead>
                <tr>
                  <th>N°</th>
                  <th>Constancia</th>
                  <th>Fecha</th>
                  <th>N° Vuelo</th>
                  <th>Regional</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(vuelo, idx) in vuelos" :key="vuelo.id">
                  <td>{{ (paginaActual - 1) * vuelosPorPagina + idx + 1 }}</td> <!-- Enumeración global -->
                  <td>{{ vuelo.numero_constancia }}</td>
                  <td>{{ vuelo.fecha }}</td>
                  <td>{{ vuelo.numero_vuelo }}</td>
                  <td>
                    {{
                      regionales.find(r => r.id == vuelo.regional_id || r.id == vuelo.regional)?.nombre
                      || vuelo.regional
                    }}
                  </td>
                  <td>
                    <md-button class="md-icon-button btn-ver" @click="verDetalle(vuelo)" title="Ver">
                      <md-icon>visibility</md-icon>
                    </md-button>

                    <template v-if="rolUsuario === 'admin'">
                      <md-button class="md-icon-button btn-editar" @click="editarVuelo(vuelo)" title="Editar">
                        <md-icon>edit</md-icon>
                      </md-button>
                      <md-button class="md-icon-button btn-eliminar" @click="eliminarVuelo(vuelo)" title="Eliminar">
                        <md-icon>delete</md-icon>
                      </md-button>
                    </template>
                    <template v-if="puedeEditarVuelo(vuelo)">
                      <md-button class="md-icon-button btn-editar" @click="editarVuelo(vuelo)" title="Editar">
                        <md-icon>edit</md-icon>
                      </md-button>
                    </template>


                    <md-button class="md-icon-button btn-pdf" @click="exportPDF(vuelo)" title="Exportar a PDF">
                      <md-icon>picture_as_pdf</md-icon>
                    </md-button>


                  </td>
                </tr>
              </tbody>
            </md-table>
          </div>


          <!-- Paginación -->
          <div class="flex justify-center gap-4 mt-4" v-if="totalPaginas > 1">
            <md-button class="btn-paginacion" @click="paginaActual--"
              :disabled="paginaActual === 1">Anterior</md-button>
            <span class="text-sm paginacion-text">Página {{ paginaActual }} de {{ totalPaginas }}</span>
            <md-button class="btn-paginacion" @click="paginaActual++"
              :disabled="paginaActual >= totalPaginas">Siguiente</md-button>
          </div>



          <!-- Error -->
          <p v-if="error" class="text-red-600 mt-2 text-xs">{{ error }}</p>
        </md-card-content>
      </md-card>
    </div>
    <vuelo-modal :visible="mostrarModal" :modo="modalModo" :vuelo="vueloSeleccionado"
      :servicios="typeof servicios === 'object' && !Array.isArray(servicios) ? servicios : {}" :regionales="regionales"
      @cerrar="cerrarModal" @guardar="guardarEdicion" />

  </div>

</template>


<script>
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import VueloModal from '@/components/Modal/VueloModal.vue';
import QRCode from "qrcode";
import Swal from 'sweetalert2';


export default {
  components: { VueloModal },
  props: {
    dataBackgroundColor: {
      type: String,
      default: 'green'
    }
  },
  data() {
    return {
      rolUsuario: '',
      constancia: '',
      fecha: '',
      regional: '',
      numeroVuelo: '',
      vuelos: [],
      totalVuelos: 0,
      paginaActual: 1,
      vuelosPorPagina: 10,
      vueloSeleccionado: null,
      servicios: {},
      error: '',
      regionales: [],
      mostrarModal: false,
      modalModo: 'editar',
      ignorarWatcherPagina: false,
    };
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.totalVuelos / this.vuelosPorPagina);
    }
  },
  watch: {
    paginaActual() {
      if (!this.ignorarWatcherPagina) {
        this.buscarVuelos();
      }
    }
  },
  methods: {
    async obtenerRegionales() {
      try {
        const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/listar_regionales.php');
        this.regionales = await res.json();
      } catch (e) {
        this.error = 'No se pudieron cargar las regionales';
      }
    },
    async buscarVuelos() {
      this.error = '';
      this.vueloSeleccionado = null;
      this.servicios = {};
      try {
        const params = new URLSearchParams();
        if (this.constancia) params.append('constancia', this.constancia);
        if (this.fecha) params.append('fecha', this.fecha);
        if (this.regional) params.append('regional', this.regional);
        if (this.numeroVuelo) params.append('vuelo', this.numeroVuelo);
        params.append('pagina', this.paginaActual);
        params.append('limite', this.vuelosPorPagina);

        const response = await fetch(`https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/get_vuelos.php?${params}`);
        const data = await response.json();

        if (data.error) {
          this.error = data.error;
          this.vuelos = [];
          this.totalVuelos = 0;
        } else {
          this.vuelos = data.vuelos;
          this.totalVuelos = data.total;
        }
      } catch (err) {
        this.error = 'Error al buscar vuelos.';
      }
    },
    async verDetalle(vuelo) {
      try {
        const res = await fetch(`https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/get_servicios_por_constancia.php?vuelo_id=${vuelo.id}`);
        const data = await res.json();
        if (data.error) {
          this.error = data.error;
          return;
        }
        this.vueloSeleccionado = data.vuelo;
        this.servicios = data.servicios;
        this.modalModo = 'ver';
        this.mostrarModal = true;
      } catch (err) {
        this.error = 'Error al obtener detalles del vuelo.';
      }
    },
    puedeEditarVuelo(vuelo) {
      if (this.rolUsuario !== 'admin') return false;
      if (!vuelo.fecha) return false;
      const fechaVuelo = new Date(vuelo.fecha + 'T00:00:00');
      const ahora = new Date();
      const diffMs = ahora - fechaVuelo;
      const diffHoras = diffMs / (1000 * 60 * 60);
      return diffHoras >= 0 && diffHoras <=24;
    },
    async editarVuelo(vuelo) {
      try {
        // 1. Obtén los servicios registrados para el vuelo
        const res = await fetch(`https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/get_servicios_por_constancia.php?vuelo_id=${vuelo.id}`);
        const data = await res.json();
        if (data.error) {
          this.error = data.error;
          return;
        }
        this.vueloSeleccionado = data.vuelo;


        const resServicios = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/all_servicios_por_constancia.php');
        const todosLosServicios = await resServicios.json();

        let serviciosCompletos = {};
        todosLosServicios.forEach(servicio => {
          const categoria = servicio.categoria;
          if (!serviciosCompletos[categoria]) serviciosCompletos[categoria] = [];

          const yaRegistrado = (data.servicios[categoria] || []).find(s => s.servicio === servicio.nombre);
          if (yaRegistrado) {
            serviciosCompletos[categoria].push(yaRegistrado);
          } else {

            serviciosCompletos[categoria].push({
              servicio: servicio.nombre,
              valor_unitario: servicio.valor_unitario,
              constancias: '',
              total: '',
              observaciones: ''
            });
          }
        });

        this.servicios = serviciosCompletos;
        this.modalModo = 'editar';
        this.mostrarModal = false;
        this.$nextTick(() => {
          this.mostrarModal = true;
        });
      } catch (err) {
        this.error = 'Error al obtener detalles del vuelo.';
      }
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.vueloSeleccionado = null;
      this.servicios = {};
    },
    guardarEdicion(datosEditados) {
      fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/actualizar_vuelo.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datosEditados)
      })
        .then(res => res.json())
        .then(async data => {
          if (data.error) {
            this.mostrarError(data.error);
          } else {
            this.cerrarModal();
            await this.buscarVuelos();
            Swal.fire('Guardado', 'Los cambios se han guardado correctamente.', 'success');
          }
        })
        .catch(() => {
          this.mostrarError('Error al guardar los cambios.');
        });
    },

    mostrarError(mensaje) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: mensaje
      });
    },

    async eliminarVuelo(vuelo) {
      const result = await Swal.fire({
        title: `¿Eliminar Registro?`,
        text: "Esta acción no se puede revertir.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        try {
          const res = await fetch(`https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/eliminar_vuelo.php?id=${vuelo.id}`, {
            method: 'DELETE'
          });
          const data = await res.json();

          if (data.error) {
            this.mostrarError(data.error);
          } else {
            await this.buscarVuelos();
            Swal.fire('Eliminado', 'El registro ha sido eliminado.', 'success');
          }
        } catch (error) {
          this.mostrarError('Error al eliminar el registro.');
        }
      }
    },
    limpiarBusqueda() {
      this.ignorarWatcherPagina = true;
      this.constancia = '';
      this.fecha = '';
      this.regional = '';
      this.numeroVuelo = '';
      this.paginaActual = 1;
      this.vuelos = [];
      this.vueloSeleccionado = null;
      this.servicios = {};
      this.error = '';
      this.totalVuelos = 0;
      this.$nextTick(() => {
        this.ignorarWatcherPagina = false; // <-- NUEVO
      });
    },
    convertImageToBase64(url) {
      return fetch(url)
        .then(response => response.blob())
        .then(
          blob =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );
    },
    async exportPDF(vuelo) {
      const doc = new jsPDF();
      let yPos = 10;
      const logoUrl = '/fondotam.png';

      try {
        const logoBase64 = await this.convertImageToBase64(logoUrl);
        doc.addImage(logoBase64, "PNG", 12, 5, 25, 16);
      } catch (error) { }

      const regionalNombre = this.regionales.find(r => r.id == vuelo.regional_id || r.id == vuelo.regional)?.nombre || vuelo.regional;

      doc.setFontSize(12);
      doc.text("| Empresa Pública De Transporte Aéreo Militar", 45, yPos + 6);
      doc.text("Lista de Verificación de Servicios | Cuadro de Conciliación de Servicios Aeronáuticos y", 25, yPos + 14);
      doc.text("Servicios de Inspección de Carga Aeropuerto '" + regionalNombre + "'", 25, yPos + 19);
      yPos += 27;

      if (vuelo) {
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        const infoLine = `N° Constancia: ${vuelo.numero_constancia}    N° Vuelo: ${vuelo.numero_vuelo}    Fecha: ${vuelo.fecha}    Regional: ${regionalNombre}`;
        doc.text(infoLine, 15, yPos);
        yPos += 2;
        doc.setFont("helvetica", "normal");
      } else {
        doc.text("No hay información de vuelo para exportar.", 10, yPos);
        yPos += 12;
      }

      let servicios = {};
      try {
        const res = await fetch(`https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/get_servicios_por_constancia.php?vuelo_id=${vuelo.id}`);
        const data = await res.json();
        if (!data.error) servicios = data.servicios;
      } catch { }

      if (Object.keys(servicios).length > 0) {
        Object.keys(servicios).forEach(category => {
          const rows = servicios[category].map(serv => [
            serv.servicio,
            serv.valor_unitario,
            serv.constancias,
            serv.total,
            (serv.total * 6.96).toFixed(2),
            serv.observaciones
          ]);
          const header = [category, "Importe por Contrato", "Constancias", "Importe en $", "Importe en Bs", "Observaciones"];
          autoTable(doc, {
            head: [header],
            body: rows,
            startY: yPos,
            theme: "grid",
            styles: { fontSize: 8, cellPadding: 1 },
            headStyles: { fillColor: [0, 123, 255], textColor: [255, 255, 255] }
          });
          yPos = doc.lastAutoTable.finalY + 1;
        });
      }

      let summaryRows = [];
      let globalTotal = 0;
      let globalTotalBs = 0;

      Object.keys(servicios).forEach(category => {
        const catTotal = servicios[category].reduce((acc, serv) => acc + Number(serv.total), 0);
        const catTotalBs = catTotal * 6.96;
        globalTotal += catTotal;
        globalTotalBs += catTotalBs;
        summaryRows.push([category, catTotal.toFixed(2), catTotalBs.toFixed(2)]);
      });

      summaryRows.push(["Importe Total a Pagar", globalTotal.toFixed(2), globalTotalBs.toFixed(2)]);

      const pageWidth = doc.internal.pageSize.width;
      autoTable(doc, {
        head: [["Categoría", "Total ($)", "Total (Bs)"]],
        body: summaryRows,
        startY: yPos + 3,
        theme: "grid",
        styles: { fontSize: 10, halign: "right" },
        columnStyles: {
          0: { halign: "left" },
          1: { halign: "right" },
          2: { halign: "right" }
        },
        headStyles: { fillColor: [0, 123, 255], textColor: [255, 255, 255] },
        margin: { left: pageWidth * 0.4 }
      });

      // Obtener datos de usuario para el QR
      let usuario = {};
      try {
        usuario = JSON.parse(localStorage.getItem("usuario")) || {};
      } catch (e) {
        console.warn("Error al parsear usuario:", e);// eslint-disable-line no-console
      }

      const now = new Date();
      const fecha = now.toLocaleDateString('es-BO');
      const hora = now.toLocaleTimeString('es-BO', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const horaImpresion = `${hora} - ${fecha}`;


      const nombreUsuario = usuario?.nombre || 'Desconocido';
      const regionalTexto = regionalNombre || 'Regional no definida';


      const textoQR = `Documento generado por:
      Nombre: ${nombreUsuario}
      Regional: ${regionalTexto}
      Hora: ${horaImpresion}`;


      try {
        const qrDataURL = await QRCode.toDataURL(textoQR, {
          width: 200,
          margin: 1
        });

        const qrSize = 25;
        const margin = 10;

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const qrX = margin;
        const qrY = pageHeight - qrSize - margin;
        doc.setFontSize(8);
        doc.text("Documento generado por:", qrX, qrY - 2);
        doc.addImage(qrDataURL, "PNG", qrX, qrY, qrSize, qrSize);
      } catch (qrError) {
        console.error("Error al generar QR:", qrError);// eslint-disable-line no-console
        doc.setFontSize(8);
        doc.text("QR no disponible", 10, doc.internal.pageSize.height - 10);
      }

      doc.save("registro_vuelo.pdf");
    },



  },
  mounted() {
    this.obtenerRegionales();
    const usuario = JSON.parse(localStorage.getItem("usuario"));
    this.rolUsuario = usuario?.rol || 'usuario';
    this.obtenerRegionales();
  }
};
</script>
<style scoped>
.btn-ver {
  background: #1976d2 !important;

  color: #fff !important;
  box-shadow: 0 2px 8px #bdbdbd33;
  transition: background 0.2s, color 0.2s, transform 0.1s;
}

.btn-ver:hover {
  background: #0d47a1 !important;
  color: #fff !important;
  transform: scale(1.15);
}

.btn-editar {
  background: #fbc02d !important;

  color: #fff !important;
  box-shadow: 0 2px 8px #bdbdbd33;
  transition: background 0.2s, color 0.2s, transform 0.1s;
}

.btn-editar:hover {
  background: #f9a825 !important;
  color: #fff !important;
  transform: scale(1.15);
}

.btn-eliminar {
  background: #d32f2f !important;

  color: #fff !important;
  box-shadow: 0 2px 8px #bdbdbd33;
  transition: background 0.2s, color 0.2s, transform 0.1s;
}

.btn-eliminar:hover {
  background: #b71c1c !important;
  color: #fff !important;
  transform: scale(1.15);
}

.btn-paginacion {
  background: #1976d2 !important;
  color: #fff !important;
  font-weight: 600;
  transition: background 0.2s, color 0.2s, transform 0.1s;
  border-radius: 6px;
}

.btn-paginacion:hover:not(:disabled) {
  background: #0d47a1 !important;
  color: #fff !important;
  transform: scale(1.08);
}

.btn-paginacion:disabled {
  background: #bdbdbd !important;
  color: #fff !important;
  cursor: not-allowed;
  opacity: 0.7;
}

.paginacion-text {
  color: #1976d2;
  font-weight: 600;
}

@media (max-width: 600px) {
  .flex.justify-center.gap-4.mt-4 {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 0.5em !important;
  }

  .btn-paginacion {
    width: 100% !important;
    font-size: 1.1em;
  }

  .paginacion-text {
    margin: 0.5em 0;
    display: block;
    font-size: 1em;
  }
}

.md-table th,
.md-table td {
  padding: 12px 20px !important;
  text-align: center;
  vertical-align: middle;
}

.tabla-responsive {
  width: 100%;
  overflow-x: auto;
}

.md-table {
  min-width: 700px;
}

.md-icon-button.btn-pdf {
  border-radius: 50% !important;
  min-width: 44px !important;
  min-height: 44px !important;
  width: 44px !important;
  height: 44px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px #bdbdbd33;
  font-size: 1.2rem;
}

.md-icon-button .md-icon {
  font-size: 1.6rem !important;
}

.btn-pdf {
  background: #e53935 !important;
  color: #fff !important;
  transition: background 0.2s, color 0.2s, transform 0.1s;
}

.btn-pdf:hover {
  background: #b71c1c !important;
  color: #fff !important;
  transform: scale(1.15);
}
</style>